export enum AllocationViewRefreshDuration {
  NotSet = 0,
  Sec30 = 30,
  Sec60 = 60,
  Sec90 = 90,
}
